export const dataOnglet = [
  { id: 1, libelle: "Etab souscripteur" },
  { id: 2, libelle: "Enseignant" },
  { id: 3, libelle: "Création de compte parental" },
  { id: 4, libelle: "Souscription" }
]

export const moisDeLAnnee = [
  { nom: "Janvier", numero: 1 },
  { nom: "Février", numero: 2 },
  { nom: "Mars", numero: 3 },
  { nom: "Avril", numero: 4 },
  { nom: "Mai", numero: 5 },
  { nom: "Juin", numero: 6 },
  { nom: "Juillet", numero: 7 },
  { nom: "Août", numero: 8 },
  { nom: "Septembre", numero: 9 },
  { nom: "Octobre", numero: 10 },
  { nom: "Novembre", numero: 11 },
  { nom: "Décembre", numero: 12 }
];